var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.splitted),function(citacao,index){return _c('citacao',{key:index,attrs:{"citacao":citacao,"nome":_vm.nome}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }